export default "__VITE_ASSET__BZ7$C23$__"